import React from 'react'
import styled from 'styled-components'

const LinkBack = (): JSX.Element => (
  <Wrapper>
    <i className="fa fa-angle-left"></i>
    <a href="/admin2/admin/prospects/">Retour à la liste</a>
  </Wrapper>
)

const Wrapper = styled.div`
  font-size: 12px;
  & > a {
    color: #333333;
    text-decoration: none;
  }
`

export default LinkBack
